/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useRef } from "react"
import { ANIMATE_DELAY, ANIMATED_STYLE } from "src/libs/interfaces/animated"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention } from "src/libs/utilities"
import { BACKGROUND_EFFECT_TYPE, defaultPosition, ILandingPrimitive } from "src/modules/pe-landing-module/data/interfaces"
import { useAnimated } from "src/modules/pe-landing-module/hooks/useAnimated"
import { useAnimatedStyle } from "src/modules/pe-landing-module/hooks/useAnimatedStyle"
import { useIScroll } from "src/modules/pe-landing-module/hooks/useIScroll"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"

/* Protopia Ecosystem component */
export interface ICanvasFieldProps {
    children: JSX.Element
    primitive:ILandingPrimitive 
    animated?: ANIMATED_STYLE 
    animated_delay? : string | number
    i:number
}
const PrimitiveContainer = ({ i, ...props}: ICanvasFieldProps): JSX.Element => {
    const primitive =  props.primitive 
    const { id, isHidden, effect, parallax_y_offset, style, isInline, } = primitive 
    const {position} = usePosition(primitive)
    // const position = {...defaultPosition(), ...primitive.position}
    const ref = useRef(null)
    const scroll  = useIScroll( ref, effect ) 
    const _style = useMemo(() => {
        let st = { ...style }
        delete st.transform
        return st
    },[]) 
    
    const animated_delay =  props.animated_delay || ""
    const ref2 = useRef(null)
    useAnimated( ref2, animated_delay )
    const animate   = useAnimatedStyle(props, i || 0)

    useEffect(() => { 
        let translateY: string = "", pOffset = 0
        switch ( effect ) {
            case BACKGROUND_EFFECT_TYPE.VERTICAL_PARALLAX: 
                pOffset = 0 // scroll * ( parallax_speed || -0.1 ) - ( parallax_y_offset || -100 )
                break
            case BACKGROUND_EFFECT_TYPE.FIXED: 
                pOffset = scroll - ( parallax_y_offset || 0 )
                break
            default: 
                pOffset = 0
        }

        translateY = `translateY(${ pOffset }px)`
        addCSSClass(
            `primitive-cont-${ id }-${ i }`,
            `.primitive-outer-${ id }-${ i } { 
                ${ isInline ? "position:relative!important;" : ""}
                width: ${getCssDemention(position.width )}; 
                height: ${getCssDemention(position.height)};
            }
            .primitive-inner-${ id }-${ i } { 
                ${ isInline ? "position:relative!important;" : ""} 
                ${ position.opacity ? `opacity:${ position.opacity };` : ``}
                ${ `transform: ${translateY}` }
            }`
        ) 
        return () => {
            removeCSSClass(`primitive-cont-${ id }-${ i }`)
        }
    },[primitive, position])
    
    if(isHidden) return <></>
    
    return <div className={`pe-primitive-field-outer-container primitive-outer-${ id }-${ i }`} ref={ref}>
        <div 
            className={`pe-primitive-field-inner-container primitive-inner-${ id }-${ i }`}
            style={{
                // transform
            }}
        >
            <div className={`primitive-animte ${animate}`} ref={ref2}> 
                {props.children}
            </div>
        </div>
    </div>
}
export default PrimitiveContainer